import BaseCommand from "@/models/api/commands/BaseCommand";

export class OwnerChangeCommand extends BaseCommand {
  CommandName = "OwnerChange";
  Command: Array<unknown>;
  constructor(sessionId: string, operationId: string, ownerId: number, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = [ownerId, orderItemId];
  }
}
